import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-voltar',
  templateUrl: './voltar.component.html',
  styleUrl: './voltar.component.scss',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonModule,
  ]
})
export class VoltarComponent implements OnInit {
  public translate = inject(TranslateService);
  location = inject(Location);
  @Input() title!: string; // Propriedade que recebe o dado do pai


  constructor() {}

  //#region Inicialização
  ngOnInit() {}

  //#endregion

  //#region Actions
  voltar() {
    this.location.back();
  }
  //#endregion
}
